import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { OrganizationsGridComponent } from './pages/organizations-grid/organizations-grid.component';
import { UsersByOrganizationsGridComponent } from './pages/users-by-organizations-grid/users-by-organizations-grid.component';
const routes: Routes = [
    { path: '', redirectTo: 'list', pathMatch: 'full' },
    { path: "list", component: OrganizationsGridComponent },
    { path: "list/usersByOrganization/:id", component: UsersByOrganizationsGridComponent}
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [],
    declarations: [],
})
export class OrganizationsRoutingModule { }